module.exports = __webpack_public_path__ + "img/exclamation.f1b53ced.svg";